import { useState } from "react";
import type { GovernanceOverview } from "../application/round03-service";
import type { BusinessContextView } from "../application/round02-service";
import type { CEOOSDatabase } from "../db/database";
import type { CEOProfile } from "../domain/types";
import { FocusGuard } from "./FocusGuard";
import { PromiseLedger } from "./PromiseLedger";
import { TruthAudit } from "./TruthAudit";
import type { GovernanceArea } from "../ui/GovernanceTabs";

export function GovernanceHub({
  database,
  overview,
  profile,
  context,
  dateKey,
  online,
  initialArea,
  onAreaChange,
  onRefresh,
}: {
  database: CEOOSDatabase;
  overview: GovernanceOverview;
  profile: CEOProfile;
  context?: BusinessContextView | undefined;
  dateKey: string;
  online: boolean;
  initialArea: GovernanceArea;
  onAreaChange: (area: GovernanceArea) => void;
  onRefresh: () => Promise<void>;
}) {
  const [area, setArea] = useState(initialArea);
  const changeArea = (next: GovernanceArea) => {
    setArea(next);
    onAreaChange(next);
  };

  if (area === "focus") {
    return (
      <FocusGuard
        database={database}
        overview={overview.focus}
        profile={profile}
        context={context}
        dateKey={dateKey}
        onAreaChange={changeArea}
        onRefresh={onRefresh}
      />
    );
  }
  if (area === "promise") {
    return (
      <PromiseLedger
        database={database}
        overview={overview.promise}
        profile={profile}
        onAreaChange={changeArea}
        onRefresh={onRefresh}
      />
    );
  }
  return (
    <TruthAudit
      database={database}
      overview={overview.truth}
      dateKey={dateKey}
      online={online}
      area="truth"
      onAreaChange={changeArea}
      onRefresh={onRefresh}
    />
  );
}
